import styled from '@emotion/styled';
import { BUTTON_COLOR } from './constants';
import type { SocialShareButtonType } from './types';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 12px;
`;

export const CopyContainer = styled.div`
  margin-top: 12px;
  display: flex;
  justify-content: center;
`;

export const Button = styled.a<{ type: SocialShareButtonType }>`
  transition: top 0.2s ease-in-out;

  padding: 8px;
  font-size: 14px;
  color: ${(props) => props.theme.color.light.default};
  background: ${(props) => BUTTON_COLOR[props.type]};
  border-radius: 5px;
  text-decoration: none;

  display: flex;
  align-items: center;
  justify-content: center;

  & > *:not(:last-child) {
    margin-right: 6px;
  }

  &:hover {
    top: -4px;
    cursor: pointer;
    border-bottom: none !important;
  }
`;
